import React from 'react'

import classes from './style.module.css'

import Payway from '../../../../elements/payway'
import getMinMaxLimitsObj from './function/getMinMaxLimitsObj'

import store from '../../../../../redux'
import { paywayAction } from '../../../../../redux/stores/firstScreen/action'
import { amountInputHandler } from './renderAmount'
import hideAnimation from '../../../../../services/hideAnimation'
import { hideScreenModal } from '../../../../../redux/stores/ScreenModalStore/action'

const { dispatch } = store

export const paywayChangeHandled = async (event) => {
    const state = store.getState().firstScreen

    const payway = event.target.value
    const minMaxLimits = await getMinMaxLimitsObj(state.allExchangeWays, state.inCurrency, state.outCurrency, payway)
    dispatch(paywayAction(state, payway, minMaxLimits))

    if (state.amount) {
        const newState = store.getState().firstScreen
        amountInputHandler(newState, newState.amount)
    }
    
    hideAnimation('selectModal-payway', hideScreenModal)
}

// Payways
const Payways = (props) => {

    const { state } = props

    const mainPayway = ['VISA_MC_P2P', 'VISA_MC', 'QIWI', 'MOBILE_PHONE']

    let exchangeWays = state.allExchangeWays
    exchangeWays = state.inCurrency ? exchangeWays.filter(way => way.inCurrency.code === state.inCurrency) : exchangeWays
    exchangeWays = state.outCurrency ? exchangeWays.filter(way => way.outCurrency.code === state.outCurrency) : exchangeWays

    let paywaysArray = Array.from(new Set(exchangeWays.map(way => {
        switch (way.exchangeWayType) {
            case 'BUY':
                return way.inPaywayCode
            case 'SELL':
                return way.outPaywayCode
            default:
                return null
        }
    })))

    return (
        <div className={classes.payways__wrapper}>
            {paywaysArray.filter(way => mainPayway.includes(way)).map((paywayCode, index) => {
                if (paywayCode.toString().indexOf('VISA_MC') !== -1 || paywayCode.toString() === 'QIWI') {
                    return (
                        <div className={classes.payway__payway} key={index}>
                            <input
                                id={'payways__input' + index}
                                name='payways__input'
                                type='radio'
                                value={paywayCode}
                                onChange={event => paywayChangeHandled(event)}
                                disabled={!state.inCurrency || !state.outCurrency}
                                checked={state.payway === paywayCode}
                            />
                            <label htmlFor={'payways__input' + index}>
                                <div className={classes.payways_input}>
                                    <Payway
                                        payway={paywayCode}
                                        checked={state.payway}
                                    />
                                </div>
                            </label>
                        </div>
                    )
                }
            })}
        </div>
    )
}

export default Payways